export async function withLoadingHidePagination(
  setStateFn: React.Dispatch<React.SetStateAction<boolean>>,
  asyncCallback: () => Promise<unknown>,
) {
  setStateFn(true);
  try {
    await asyncCallback();
  } catch {}

  setStateFn(false);
}
